import { z } from 'zod';

/** Calendar date with no time zone, always interpreted in America/Los_Angeles (the farm's clock). */
export const isoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Use a YYYY-MM-DD date');
export type IsoDate = z.infer<typeof isoDateSchema>;

/** Money is always stored and sent as integer cents — never floating-point dollars. */
export const centsSchema = z.number().int();
export type Cents = z.infer<typeof centsSchema>;

/** Deployment stage: local laptop, a PR preview (pr-123), staging, or production. */
export const stageSchema = z.string().regex(/^(local|staging|prod|pr-\d+)$/, 'Unknown stage');
export type Stage = z.infer<typeof stageSchema>;

/** The farm's time zone. Every "today", sales week and schedule uses it. */
export const FARM_TIME_ZONE = 'America/Los_Angeles';

/** HTTP headers shared by the web client and the API. */
export const HEADERS = {
  /** Build version of the web client, so the API can ask stale phones to update. */
  clientBuild: 'x-bnb-build',
  /** Local-only persona login. The API rejects it unless STAGE=local. */
  devPersona: 'x-bnb-dev-persona',
  requestId: 'x-request-id',
} as const;
